import { connect } from 'react-redux';
import DataMapel from '../../views/Settings/DataMapel.view';
import { manageRegistration } from '../../states/thunks/student.thunk';
import {
  getParamOptions, getParamOptionsAcademics, getClassesOptions, getPeriodsOptions, getPrmLevels, getSchoolUnitsOptions, getParamPerwakilan,
} from '../../states/thunks/options.thunk';
import {
  listStudentCountClass, studentCount, listStudentCountUnits, listDataMapelPerwakilan, listDataMapelUnit,
} from '../../states/thunks/academics.thunk';


function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},

  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleStudentCount: payload => dispatch(studentCount(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleListStudentCountClass: (payload, goback) => dispatch(listStudentCountClass(payload, goback)),
    handleListStudentCountUnits: (payload, goback) => dispatch(listStudentCountUnits(payload, goback)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleListDataMapelUnit: (payload, goback) => dispatch(listDataMapelUnit(payload, goback)),
    handleListDataMapelPerwakilan: (payload, goback) => dispatch(listDataMapelPerwakilan(payload, goback)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DataMapel);
